const actionTypeIdentifier = "1A64969A-9549-4EB7-99D7-E48578E462CE";

export const setEquipmentHistoryLogsLoading = `SET-EQUIPMENT-HISTORY-LOGS-LOADING-${actionTypeIdentifier}`;
export const getEquipmentHistoryLogs = `GET-EQUIPMENT-HISTORY-LOGS-${actionTypeIdentifier}`;
export const setEquipmentHistoryPageSize = `SET-EQUIPMENT-HISTORY-PAGE-SIZE-${actionTypeIdentifier}`;
export const resetEquipmentHistory = `RESET-EQUIPMENT-HISTORY-${actionTypeIdentifier}`;
export const setEquipmentHistoryColSearchStr = `SET-EQUIPMENT-HISTORY-COL-SEARCH-${actionTypeIdentifier}`;